import { Avatar, Divider, Grid, Typography } from '@mui/material';
import './transaction.css';
import React, { useEffect, useState } from 'react';
import ReactPaginate from "react-paginate";
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useTheme, useMediaQuery } from '@mui/material';
import { formatMoney } from '../../utils/function/Function';
import Color from '../../layouts/Color';

// ==============================|| Pagenation Transaction History ||============================== //
const divide = { my: 1.5 };

const PaginationHistory = (props) => {
  const theme = useTheme();
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const [histories, setHistories] = useState([])
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (props.historyReload !== null) {
      setHistories(props.historyReload)
    }
  }, [props.historyReload])

  const limit = 7;
  const pagesVisited = pageNumber * limit;

  const displayUsers = histories
    .slice(pagesVisited, pagesVisited + limit)
    .map((history, index) => {
      return (
        <div key={index}>
          <Grid container direction="column" sx={{ pl: props.center ? (matchDownXL ? 0 : 20) : 0, pr: props.center ? (matchDownXL ? 0 : 20) : 0 }}>
            <Grid item >
              <Grid container alignItems="center" textAlign="start" justifyContent="space-between" sx={{ display: matchDownMD ? 'block' : 'flex' }}>
                <Grid item >
                  <Typography variant="subtitle1" color="inherit">
                    {history.partnerNumber}
                  </Typography>
                </Grid>
                <Grid item >
                  <Grid container alignItems="center" >
                    {history.transAmount < 0 ? (
                      <>
                        <Grid item>
                          <Typography variant="subtitle1" color={Color.Dangerous}>
                            {/* {history.transAmount} */}
                            {formatMoney(history.transAmount.replace(/-/g, " "), ' VND')}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 16,
                              height: 16,
                              borderRadius: '5px',
                              backgroundColor: theme.palette.orange.light,
                              color: theme.palette.orange.dark,
                              ml: 2
                            }}
                          >
                            <KeyboardArrowUpOutlinedIcon fontSize="small" color="inherit" />
                          </Avatar>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item>
                          <Typography variant="subtitle1" >
                            {formatMoney(history.transAmount.replace(/-/g, " "), ' VND')}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 16,
                              height: 16,
                              borderRadius: '5px',
                              backgroundColor: theme.palette.success.light,
                              color: theme.palette.success.dark,
                              ml: 2
                            }}
                          >
                            <KeyboardArrowDownOutlinedIcon fontSize="small" color="inherit" />
                          </Avatar>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container alignItems="center" textAlign="start" justifyContent="space-between" sx={{ display: matchDownMD ? 'block' : 'flex' }}>
                <Grid item>
                  <Typography variant="subtitle2" >
                    {history.transDetails}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="subtitle2">
                    {history.transDate.replace(/T/g, " ")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={divide} />
        </div >
      );
    });

  const pageCount = Math.ceil(histories.length / limit);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return histories !== null ? (
    <div>
      {displayUsers}
      <div >
        <ReactPaginate
          pageCount={pageCount}
          onPageChange={changePage}
          containerClassName={"paginationBttns"}
          previousLinkClassName={"previousBttn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
          pageClassName={'pageClassName'}
          breakLabel="..."
          pageRangeDisplayed={3}
          nextLabel={<ArrowRightIcon />}
          previousLabel={<ArrowLeftIcon />}
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default PaginationHistory;